import { render } from "./paramChangeMdlRequest.vue?vue&type=template&id=6b0c8314"
import script from "./paramChangeMdlRequest.vue?vue&type=script&lang=js"
export * from "./paramChangeMdlRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__